module.exports = __webpack_public_path__ + "static/media/NeoVantium black.15580198.png";